module.exports = __webpack_public_path__ + "static/media/libraryapp.dad4fd14.png";